module.exports = __webpack_public_path__ + "media/assets/icons/mail-d964eade99d54e860a1fbc4d04acc173.svg";